<template>
    <div style="text-align: left">
        <div class="list">批次管理</div>
        <div class="content">
            <div class="goods">
                <div style="flex:2;display: flex; ">
                    <div style="width:300px">
                        批次名称：<el-input placeholder="请输入批次名称" class="input-with-select" style="max-width: 200px;"
                            v-model="batchList.batchName"></el-input>
                    </div>
                    <el-button @click="search" type="primary">搜 索</el-button>
                    <el-button @click="reset" style="margin-left: 20px" type="primary" plain>重 置</el-button>
                    <el-button @click="returnPage" style="margin-left: 20px" type="primary" plain>返 回</el-button>
                </div>
                <br />
                <hr>
                <div style="margin-top: 20px">
                    <el-button type="primary" plain @click="openDialog('ruleForm')">新增批次</el-button>
                    <!-- <el-button type="primary" plain>批量删除</el-button> -->
                </div>
            </div>
            <br />
            <div class="global-table-box">
                <el-table :data="tableData" border style="width: 100%" @selection-change="handleSelectionChange"
                    :cell-style="{}" header-align="center">
                    <!-- <el-table-column type="selection" width="55" align="center">
                </el-table-column> -->
                    <el-table-column type="index" width="50" label="序号" header-align="center" align="center">
                    </el-table-column>
                    <el-table-column prop="batchName" label="批次名称" width="300" header-align="center" align="center">
                    </el-table-column>
                    <el-table-column label="通知" header-align="center" align="center" width="300">
                        <template slot-scope="scope">
                            <el-tooltip class="item" effect="light" :content="scope.row.noticeContent" placement="bottom">
                                <template slot="content">
                                    <p class="notice" style="max-width:200px;">{{ scope.row.noticeContent }}</p>
                                </template>
                                <div class="notice-content"> {{ scope.row.noticeContent }}</div>
                            </el-tooltip>
                        </template>
                    </el-table-column>
                    <!-- <el-table-column prop="phone" label="客服电话" width="200" header-align="center" align="center">
                    </el-table-column> -->
                    <el-table-column prop="startTime" label="开始时间" header-align="center" width="200" align="center">
                    </el-table-column>
                    <el-table-column prop="endTime" label="结束时间" width="200" header-align="center" align="center">
                    </el-table-column>
                    <el-table-column prop="endTime" label="签收状态" width="200" header-align="center" align="center">
                        <template slot-scope="scope">
                            {{ scope.row.signFor | isSignFor }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="endTime" label="签收时间" width="200" header-align="center" align="center">
                        <template slot-scope="scope">
                            {{ scope.row.signFor }}
                        </template>
                    </el-table-column>
                    <!-- <el-table-column label="二维码" width="00" header-align="center" align="center">
                        <template slot-scope="scope">
                            <el-button>{{ scope.row.qrcode }}</el-button>
                        </template>
                    </el-table-column> -->
                    <el-table-column label="操作" header-align="center" align="center" fixed="right" width="450px">
                        <template slot-scope="scope">
                            <!-- <el-button type="text" size="small">详情</el-button> -->
                            <el-button type="text" size="small" @click="editorEcho(scope.row)">编辑</el-button>
                            <el-button type="text" size="small" @click="openProlong(scope.row)">延期</el-button>
                            <el-button type="text" size="small" @click="openResetProlong(scope.row)">重置</el-button>
                            <el-button @click="deleteBatch(scope.row)" type="text" size="small">删除</el-button>
                            <el-button @click="addGrade(scope.row)" type="text" size="small">添加年级</el-button>
                            <el-button @click="batchGrade(scope.row, 'batchGoods')" type="text"
                                size="small">批次商品</el-button>
                            <el-button type="text" size="small" @click="openCode(scope.row)">生成二维码</el-button>
                            <el-button type="text" size="small" @click="forBatch(scope.row)"
                                :disabled="scope.row.signFor != null">确认签收</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="block">
                <el-pagination @current-change="handleCurrentChange" :current-page.sync="batchList.pageNum"
                    layout="prev, pager, next, jumper" :total="total" :page-size="10">
                </el-pagination>
            </div>

        </div>

        <el-dialog title="二维码" :visible.sync="TwoDimensionalCode" width="400px" top="10vh" :before-close="handleClose">
            <!-- //这里是要生成图片的区域 -->
            <div class="poster-aside" id="poster-aside">
                <!-- <img :src="imgUrl + '' + promotionBackgroundUrl" class="img1"> -->
                <img src="../static/images/towCode.jpg" alt="" class="img">
                <div class="code-cont">
                    <p class="head-text">欢迎使用在线征订系统</p>
                    <!-- <p class="title">{{ TwoCode.batchName }}</p> -->
                    <p class="subscription-time">
                        征订时间：<span>{{ TwoCode.startTime }}</span>
                        <!--<span>{{ this.TwoCode.endTime }}</span> -->
                    </p>
                    <p class="subscription-time">
                        结束时间：<span>{{ TwoCode.endTime }}</span>
                        <!--<span>{{ this.TwoCode.endTime }}</span> -->
                    </p>
                    <div class="cont">
                        <div class="logo">
                            <img :src="TwoCode.url" alt="">
                            <span>{{ TwoCode.schoolName + '提醒您:' }}</span>
                        </div>
                        <div class="subscription-prompt">
                            校服订购工作开始了！请您扫码进入公众号开启订购。
                        </div>
                        <div class="tow-code">
                            <div id="qrcode" ref="qrCodeUrl"></div>
                            <div style="display: flex; align-items: center; margin-left: 50px;">
                                <img style="position: relative; top: 9px;left: 10px;"
                                    src="../static/images/upwardCenter.png" alt="">
                                <span>长按识别二维码</span>
                            </div>

                        </div>
                        <!-- <div class="school-number">入口编码：{{ TwoCode.batchName }}</div> -->
                        <!-- <div class="contact-number">客服电话：{{ TwoCode.phone }}</div> -->
                        <div class="company-name">此次征订由青岛顺聚祥商贸有限公司提供</div>
                    </div>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="TwoDimensionalCode = false">取 消</el-button>

                <a class="poster-download" @click="downloadCodeImg">下载</a>
                <!-- <el-button v-if="voidBut" :disabled="true" class="void-but" type="primary">下载</el-button> -->
            </span>
        </el-dialog>

        <!-- 新增批次 -->
        <el-dialog :title="(ruleForm.id ? '编辑' : '新增')" :visible.sync="dialogVisible" width="35%"
            :before-close="handleClose">
            <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
                <el-form-item label="批次名称" prop="batchName">
                    <el-input v-model="ruleForm.batchName"></el-input>
                </el-form-item>
                <el-form-item label="批次标签" prop="batchLabel">
                    <!-- <el-input v-model="ruleForm.batchLabel"></el-input> -->
                    <el-select v-model="ruleForm.batchLabel" clearable placeholder="请选择">
                        <el-option label="统购" value="统购"></el-option>
                        <el-option label="增订" value="增订"></el-option>
                        <el-option label="政府采购" value="政府采购"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="学段" prop="period">
                    <!-- <el-input v-model="ruleForm.batchLabel"></el-input> -->
                    <el-select v-model="ruleForm.period" clearable placeholder="请选择">
                        <el-option label="幼儿园" value="幼儿园"></el-option>
                        <el-option label="小学" value="小学"></el-option>
                        <el-option label="初中" value="初中"></el-option>
                        <el-option label="高中" value="高中"></el-option>
                        <el-option label="中专/大专" value="中专/大专"></el-option>
                        <el-option label="大学" value="大学"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="物流类型" prop="logisticsType">
                    <!-- <el-input v-model="ruleForm.batchLabel"></el-input> -->
                    <el-select v-model="ruleForm.logisticsType" clearable placeholder="请选择">
                        <el-option label="配送到校" value="配送到校"></el-option>
                        <el-option label="自提点自取" value="自提点自取"></el-option>
                        <el-option label="快递到家" value="快递到家"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="批次运费" prop="transportationTotal" v-if="ruleForm.logisticsType === '快递到家'">
                    <el-input v-model.trim="ruleForm.transportationTotal" style="width:220px"></el-input>
                </el-form-item>
                <el-form-item label="通知公告" prop="notification">
                    <el-radio-group v-model="ruleForm.notification">
                        <el-radio :label="1">开启</el-radio>
                        <el-radio :label="0">关闭</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="公告内容" prop="notificationContent" v-if="ruleForm.notification === 1">
                    <el-input type="textarea" v-model="ruleForm.notificationContent"></el-input>
                </el-form-item>
                <el-form-item label="购物车通知" prop="shoppingContent">
                    <el-input type="textarea" v-model="ruleForm.shoppingContent"></el-input>
                </el-form-item>
                <!-- <el-form-item label="客服电话" prop="phone">
                    <el-input v-model="ruleForm.phone" style="width:220px"></el-input>
                </el-form-item> -->
                <el-form-item label="开始时间" prop="startTime">
                    <el-date-picker v-model="ruleForm.startTime" value-format="yyyy-MM-dd HH:mm:ss" type="datetime"
                        placeholder="选择日期时间">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="结束时间" prop="endTime">
                    <el-date-picker v-model="ruleForm.endTime" value-format="yyyy-MM-dd HH:mm:ss" type="datetime"
                        placeholder="选择日期时间">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="通知内容" prop="noticeContent">
                    <el-input type="textarea" v-model="ruleForm.noticeContent"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="resetForm('ruleForm')">取 消</el-button>
                <el-button type="primary" @click="submitForm('ruleForm')" v-if="!ruleForm.id">确 定</el-button>
                <el-button type="primary" @click="editorBatch('ruleForm')" v-if="ruleForm.id">编 辑</el-button>
            </span>
        </el-dialog>
        <!-- 延长批次 -->
        <el-dialog :title="resetBut ? '重置批次' : '延期批次'" :visible.sync="prolong" width="35%" :before-close="handleClose">
            <el-form :model="ruleFormProlong" :rules="rulesProlong" ref="ruleFormProlong" label-width="100px"
                class="demo-ruleForm">
                <el-form-item label="批次名称" prop="batchName">
                    <el-input v-model="ruleFormProlong.batchName" disabled></el-input>
                </el-form-item>
                <el-form-item label="开始时间" prop="startTime">
                    <el-date-picker v-model="ruleFormProlong.startTime" disabled value-format="yyyy-MM-dd HH:mm:ss"
                        type="datetime" placeholder="选择日期时间">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="结束时间" prop="endTime">
                    <el-date-picker v-model="ruleFormProlong.endTime" disabled value-format="yyyy-MM-dd HH:mm:ss"
                        type="datetime" placeholder="选择日期时间">
                    </el-date-picker>
                </el-form-item>
                <!-- {{ ruleFormProlong.endTimeProlong }} -->
                <el-form-item label="延长时间" prop="endTimeProlong" v-if="!resetBut">
                    <el-date-picker v-model="ruleFormProlong.endTimeProlong" value-format="yyyy-MM-dd HH:mm:ss"
                        type="datetime" placeholder="选择日期时间">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="开始时间" prop="startTimeProlong" v-if="resetBut">
                    <el-date-picker v-model="ruleFormProlong.startTimeProlong" value-format="yyyy-MM-dd HH:mm:ss"
                        type="datetime" placeholder="选择日期时间">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="结束时间" prop="endTimeProlong" v-if="resetBut">
                    <el-date-picker v-model="ruleFormProlong.endTimeProlong" value-format="yyyy-MM-dd HH:mm:ss"
                        type="datetime" placeholder="选择日期时间">
                    </el-date-picker>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="prolong = false">取 消</el-button>
                <el-button type="primary" @click="subPostpone" v-if="!resetBut">确 定</el-button>
                <el-button type="primary" @click="subResetPostpone" v-if="resetBut">确 定</el-button>
            </span>
        </el-dialog>


        <!-- 批次商品 -->
        <el-dialog title="编辑商品" :visible.sync="outerVisible" width="40%" :before-close="handleClose">
            <el-form :model="batchGoods" ref="batchGoods" label-width="100px" class="demo-ruleForm"
                style="min-height:590px;max-height:590px;overflow: auto;">
                <el-form-item v-for="(item, index) in batchGoods.addBatchGoodsListDtos" :key="index"
                    :label="`商品${index + 1}`" style="padding-left:0">
                    <el-form-item label="商品名称" :rules="rulesBatchGoods.goodsName"
                        :prop="`addBatchGoodsListDtos[${index}].goodsName`">
                        <el-input v-model="batchGoods.addBatchGoodsListDtos[index].goodsName" disabled></el-input>
                    </el-form-item>
                    <el-form-item label="商品图片">
                        <div class="demo-image__preview">
                            <el-image style="width: 100px; height: 100px" :src="imgUrlBig[index][0]"
                                :preview-src-list="imgUrlBig[index]">
                            </el-image>
                        </div>
                    </el-form-item>
                    <el-form-item label="设置金额" :rules="rulesBatchGoods.setAmount"
                        :prop="`addBatchGoodsListDtos[${index}].setAmount`">
                        <el-input v-model="batchGoods.addBatchGoodsListDtos[index].setAmount"
                            oninput="value=value.replace(/[^0-9.]/g,'')" :disabled="isTrue"></el-input>
                    </el-form-item>
                    <el-form-item label="优惠数量" :rules="rulesBatchGoods.discountCount"
                        :prop="`addBatchGoodsListDtos[${index}].discountCount`">
                        <el-input v-model="batchGoods.addBatchGoodsListDtos[index].discountCount"
                            oninput="value=value.replace(/[^0-9.]/g,'')"></el-input>
                    </el-form-item>
                    <el-form-item label="最小数量" :rules="rulesBatchGoods.setCount"
                        :prop="`addBatchGoodsListDtos[${index}].setCount`">
                        <el-input v-model="batchGoods.addBatchGoodsListDtos[index].setCount"
                            oninput="value=value.replace(/[^0-9.]/g,'')"></el-input>
                    </el-form-item>
                    <el-form-item label="最大数量" :rules="rulesBatchGoods.setMaxCount"
                        :prop="`addBatchGoodsListDtos[${index}].setCount`">
                        <el-input v-model="batchGoods.addBatchGoodsListDtos[index].setMaxCount"
                            oninput="value=value.replace(/[^0-9.]/g,'')"></el-input>
                    </el-form-item>
                    <el-form-item label="重量" :rules="rulesBatchGoods.transportationTotal"
                        :prop="`addBatchGoodsListDtos[${index}].transportationTotal`" v-if="isTransportationTotal">
                        <el-input :disabled="true" v-model="batchGoods.addBatchGoodsListDtos[index].transportationTotal"
                            oninput="value=value.replace(/[^0-9.]/g,'')"></el-input>
                    </el-form-item>
                    <el-form-item label="排序" :prop="`addBatchGoodsListDtos[${index}].goodsSort`">
                        <el-input v-model="batchGoods.addBatchGoodsListDtos[index].goodsSort"
                            oninput="value=value.replace(/[^0-9.]/g,'')"></el-input>
                    </el-form-item>
                    <el-button @click="removeGoods(item)">删除</el-button>
                </el-form-item>

            </el-form>

            <el-dialog width="50%" title="商品列表" :visible.sync="innerVisible" append-to-body>
                <div class="img-search">
                    <el-input v-model="goodsListParameter.goodsName"></el-input>
                    <el-button style="margin-left:10px" type="primary" @click="searchGoods">搜索</el-button>
                    <el-button plain type="primary" @click="resetGoods">重置</el-button>
                </div>
                <div class="img-choose">
                    <div class="single-goods" v-for="(item, index) in goodsList" :key="index" :attr="JSON.stringify(item)"
                        @click="activeImg(index)">

                        <img :src="item.pictureUrl" :alt="item.goodsName">
                        <p>
                            商品名称：<span>{{ item.goodsName }}</span>
                        </p>
                        <p>
                            商品类型<span>{{ item.categoryName }}</span>
                        </p>
                        <div :class="(index === isActive) ? 'is-active' : ''"></div>

                    </div>
                </div>
                <div slot="footer" class="dialog-footer" style="display:flex;justify-content: space-between;">
                    <el-button type="primary" plain @click="loadMoreGoods">加载更多</el-button>
                    <div>
                        <el-button @click="cancelSelect">取 消</el-button>
                        <el-button type="primary" @click="determineGoods">确定</el-button>
                    </div>
                </div>
            </el-dialog>

            <div slot="footer" class="dialog-footer" style="display:flex;justify-content: space-between;">
                <el-button type="primary" @click="addDoodsDialog" plain>添加</el-button>
                <div>
                    <el-button @click="outerVisible = false">取 消</el-button>
                    <el-button type="primary" @click="submitFormGoods('batchGoods')">确定</el-button>
                </div>
            </div>
        </el-dialog>

        <!-- 添加年级班级 -->
        <el-dialog title="年级/班级" :visible.sync="dialogGrade" width="700px" :before-close="handleClose">
            <div v-for="(item, index) in gradeClass.arr" :key="index" style="text-align: center;">
                <span class="classAdd" style="margin-bottom: 20px; display: block;">
                    <span>年级： <el-input v-model="item.grade" style="width:200px;margin-right: 20px;"></el-input></span>
                    <span>班级： <el-input v-model="gradeClass.arrClass[index]" @blur="classList(index)"
                            style="width:100px;margin-right: 20px" :disabled="item.disabled"
                            onkeyup="value=value.replace(/[^\d]/g,'')"></el-input>
                        <!-- {{ gradeClass.arr[index].classAddListDto.length }} -->
                        <el-button @click="editClass(item)" type="primary" plain>编辑班级</el-button>
                        <el-button @click="removeGrade(item)" type="danger">删除</el-button>
                        <!-- <span style="margin-left: 20px;color: #000;" @click="editClass(item)">编辑班级</span> -->
                    </span>
                </span>
            </div>
            <div style="display:flex;justify-content: space-between;">
                <el-button @click="addClass" type="primary" plain>添加</el-button>
                <div>
                    <el-button @click="cancelClass">取消</el-button>
                    <el-button @click="addGradeClass" type="primary">确定</el-button>
                </div>
            </div>

            <el-dialog width="350px" title="班级" :visible.sync="innerVisibleClass" append-to-body>
                <div style="height: 260px; overflow: auto;">
                    <div v-for="(item, index) in classDetails.cont.classAddListDto" :key="index">
                        <span class="classAdd" style="margin-bottom: 20px; display: block;">
                            <!-- <span>年级： <el-input v-model="item.grade" style="width:200px;margin-right: 20px;"></el-input></span> -->
                            <span>班级： <el-input v-model="classDetails.cont.classAddListDto[index].className"
                                    style="width:120px;margin-right: 20px" :disabled="item.disabled"></el-input>
                                <!-- {{ gradeClass.arr[index].classAddListDto.length }} -->
                                <el-button type="danger" @click="deleteClass(item)">删除</el-button>
                            </span>
                        </span>
                    </div>
                </div>

                <div>
                    <el-button type="primary" @click="addClassOne" plain>添加班级</el-button>
                </div>
                <div style="text-align: right;">
                    <el-button type="primary" @click="innerVisibleClass = false" plain>取消</el-button>
                    <el-button type="primary" @click="confirmClassInfo" plain>确认</el-button>
                </div>
            </el-dialog>


        </el-dialog>
    </div>
</template>


<script>
import request from '../utils/request'
import QRCode from 'qrcodejs2'
import html2canvas from "html2canvas"
export default {
    data() {
        return {
            // 是否可改商品价格
            isTrue: false,
            // 当前时间
            currentTime: '',
            // 班级明细
            classDetails: {
                index: '',
                cont: {}
            },
            // 设置班级弹窗
            innerVisibleClass: false,
            // 延期数据
            ruleFormProlong: {
                endTimeProlong: null,
                startTimeProlong: null
            },
            //批次延长弹窗
            prolong: false,
            // 年级班级数组
            gradeClass: {
                arr: [],
                arrClass: []
            },
            // 年级班级弹窗显示隐藏
            dialogGrade: false,
            TwoCode: {},
            TwoDimensionalCode: false,
            voidBut: false,
            batchList: {
                batchName: '',
                isPage: true,
                pageNum: 1,
                pageSize: 10,
                schoolId: ''//0
            },
            tableData: [],
            //批次弹窗
            dialogVisible: false,
            // 新增表单
            ruleForm: {
                id: '',
                batchName: '',
                batchLabel: '',
                startTime: '',
                endTime: '',
                noticeContent: '',
                schoolId: '',
                logisticsType: '',
                notification: '',
                notificationContent: '',
                phone: '',
                shoppingContent: '',
                transportationTotal: '',
                period: ''
            },
            // 配送方式校验
            isTransportationTotal: false,
            // 表单效验
            rules: {
                batchName: [
                    { required: true, message: '请输入批次名称', trigger: 'blur' },
                    // { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }
                ],
                startTime: [
                    { required: true, message: '请输入开始时间', trigger: 'blur' }
                ],
                batchLabel: [
                    { required: true, message: '请选择标签', trigger: 'blur' | 'change' }
                ],
                period: [
                    { required: true, message: '请选择学段', trigger: 'blur' | 'change' }
                ],
                logisticsType: [
                    { required: true, message: '请设置物流类型', trigger: 'blur' | 'change' }
                ],
                transportationTotal: [
                    { required: true, message: '请输入运费', trigger: 'blur' },
                    {
                        pattern: /^[0-9]+(\.[0-9]{1,2})?$/g,    //正则校验不用字符串
                        message: "请填写正确的运费", trigger: "blur"
                    }
                ],
                endTime: [
                    { required: true, message: '请输入结束时间', trigger: 'blur' }
                ],
                noticeContent: [
                    { required: true, message: '请输通知内容', trigger: 'blur' }
                ],
                notification: [
                    { required: true, message: '请选择是否开启公告提示', trigger: 'blur' }
                ],
                notificationContent: [
                    { required: true, message: '请输入公告内容', trigger: 'blur' }
                ],
                // shoppingContent: [
                //     { required: true, message: '请输入购物车通知', trigger: 'blur' }
                // ],
                phone: [
                    { required: true, message: '请输入手机号码', trigger: 'blur' },
                ],
            },
            // 表单效验
            rulesProlong: {
                endTimeProlong: [
                    { required: true, message: '请输入时间', trigger: 'blur' }
                ],
                startTimeProlong: [
                    { required: true, message: '请输入时间', trigger: 'blur' }
                ],
            },
            // 批次弹窗
            outerVisible: false,
            // 商品弹窗
            innerVisible: false,
            //新增批次商品
            batchGoods: {
                addBatchGoodsListDtos: [],
                batchId: '',
                schoolId: ''
            },
            // 商品发图链接
            imgUrlBig: [],
            //新增商品的表单校验
            rulesBatchGoods: {
                goodsId: [
                    { required: true, message: '请输入商品ID', trigger: 'blur' }
                ],
                goodsName: [
                    { required: true, message: '请输入商品名称', trigger: 'blur' }
                ],
                logisticsType: [
                    { required: true, message: '请设置物流类型', trigger: 'blur' }
                ],
                setAmount: [
                    { required: true, message: '请设置金额', trigger: 'blur' }
                ],
                setCount: [
                    { required: true, message: '请设置最小购买数量', trigger: 'blur' }
                ],
                discountCount: [
                    { required: true, message: '请设置优惠数量', trigger: 'blur' }
                ],
                setMaxCount: [
                    { required: true, message: '请设置最大购买数量', trigger: 'blur' }
                ],
                transportationTotal: [
                    { required: true, message: '请设置运费', trigger: 'blur' }
                ],
            },
            //查询商品参数
            goodsListParameter: {
                pageNum: 1,
                pageSize: 10,
                goodsName: '',
                isPage: true,
                goodsType: '自有商品'
            },
            // 商品列表
            goodsList: [],
            //商品选中样式
            isActive: '',
            //选中商品
            isActiveAttr: '',
            total: 0,
            totalPage: 0,
            // 批次ID
            batchId: '',
            //重置延期
            resetBut: false
        }
    },
    methods: {
        // 获取当前时间
        getTimesInterval() {
            let _this = this;
            let year = new Date().getFullYear(); //获取当前时间的年份
            let month = new Date().getMonth() + 1; //获取当前时间的月份
            let day = new Date().getDate(); //获取当前时间的天数
            let hours = new Date().getHours(); //获取当前时间的小时
            let minutes = new Date().getMinutes(); //获取当前时间的分数
            let seconds = new Date().getSeconds(); //获取当前时间的秒数
            //当小于 10 的是时候，在前面加 0
            if (hours < 10) {
                hours = "0" + hours;
            }
            if (minutes < 10) {
                minutes = "0" + minutes;
            }
            if (seconds < 10) {
                seconds = "0" + seconds;
            }
            //拼接格式化当前时间
            _this.times = year + "-" + month + "-" + day + " " + hours + ":" + minutes + ":" + seconds;
            this.currentTime = _this.times
            // console.log(_this.times);
        },

        // 确认班级信息
        confirmClassInfo() {
            let length = this.classDetails.cont.classAddListDto.length
            this.gradeClass.arr[this.classDetails.index].classAddListDto = JSON.parse(JSON.stringify(this.classDetails.cont.classAddListDto))
            this.gradeClass.arrClass[this.classDetails.index] = length
            this.innerVisibleClass = false
        },
        // 添加单个班级
        addClassOne() {
            this.classDetails.cont.classAddListDto.push({
                className: this.classDetails.cont.classAddListDto.length + 1 + "班"
            })
        },
        // 删除班级
        deleteClass(item) {
            // console.log(item, index);
            // console.log(this.classDetails.index);
            // console.log(this.gradeClass.arr);
            // console.log(this.gradeClass.arr[this.classDetails.index]);
            let index = this.classDetails.cont.classAddListDto.indexOf(item)
            this.classDetails.cont.classAddListDto.splice(index, 1)
            // console.log(index);
            // console.log(this.gradeClass.arr);
        },
        // 延期批次信息弹窗
        openProlong(val) {
            this.ruleFormProlong.endTimeProlong = null
            this.resetBut = false
            this.prolong = true
            if (this.$refs['ruleFormProlong'] !== undefined) {
                this.$refs['ruleFormProlong'].resetFields();
            }
            this.ruleFormProlong = Object.assign(this.ruleFormProlong, val)
        },
        // 重置批次信息弹窗
        openResetProlong(val) {
            this.resetBut = true
            this.ruleFormProlong.endTimeProlong = null
            this.ruleFormProlong.s = null
            this.prolong = true
            if (this.$refs['ruleFormProlong'] !== undefined) {
                this.$refs['ruleFormProlong'].resetFields();
            }
            this.ruleFormProlong = Object.assign(this.ruleFormProlong, val)
        },
        //重置批次时间时间
        subResetPostpone() {
            this.$refs['ruleFormProlong'].validate(async (valid) => {
                if (valid) {
                    this.prolong = false
                    const res = await request({
                        method: 'POST',
                        url: '/admin/school/reset',
                        data: {
                            id: this.ruleFormProlong.id,
                            endTime: this.ruleFormProlong.endTimeProlong,
                            startTime: this.ruleFormProlong.startTimeProlong,
                        }
                    })
                    if (res.code === '200') {
                        this.$message.success(res.message)
                        this.getBatch()
                    } else {
                        this.$message.error(res.message)
                    }
                } else {
                    return false
                }

            });
        },
        //提交延期时间
        subPostpone() {
            this.$refs['ruleFormProlong'].validate(async (valid) => {
                if (valid) {
                    this.prolong = false
                    const res = await request({
                        method: 'POST',
                        url: 'admin/school/postpone',
                        data: {
                            id: this.ruleFormProlong.id,
                            endTime: this.ruleFormProlong.endTimeProlong,
                        }
                    })
                    if (res.code === '200') {
                        this.$message.success(res.message)
                        this.getBatch()
                    } else {
                        this.$message.error(res.message)
                    }
                } else {
                    return false
                }

            });
        },
        // 获取二维码参数
        async getQrcodeData(val, item) {
            this.TwoDimensionalCode = true
            const res = await request({
                method: 'POST',
                url: 'https://www.sjxsm.com/wx/wx/verify/get/qrcode',
                data: {
                    batchId: val.id,
                    schoolName: val.schoolName
                }
            })
            console.log(typeof res === 'string');
            document.getElementById('qrcode').innerHTML = ''
            if (res.length > 0) {
                // setTimeout(()=>{
                //     this.creatQrCode(val, res)
                // },200)
                await this.$nextTick(() => {
                    this.creatQrCode(res, item)
                });
            } else {
                this.TwoDimensionalCode = false
                this.$message.error('请找管理员处理')
            }
        },
        // 返回上一页
        returnPage() {
            this.$router.go(-1)
        },
        // 打开二维码弹窗
        async openCode(val) {
            // console.log(val);
            // return
            // this.TwoDimensionalCode = true

            // codeHtml.innerHTML = ;
            let data = {
                batchName: val.batchName,
                endTime: val.endTime,
                startTime: val.startTime,
                url: '',
                schoolName: '',
                schoolCode: '',
                phone: val.phone
            }
            const res = await request({
                url: `admin/school/select?schoolId=${val.schoolId}&schoolName=${val.schoolName}`,
                method: 'GET'
            })
            //console.log(res);
            if (res.code === '200') {
                data.url = res.data && res.data.pictureUrl
                data.schoolName = res.data && res.data.schoolName
                data.schoolCode = res.data && res.data.schoolCode
                this.TwoCode = data
                // this.creatQrCode(val)
                this.getQrcodeData(val, res.data)
            } else {
                this.$message.error(res.message)
            }
        },
        // 生成二维码
        creatQrCode(res) {
            document.getElementById("qrcode").innerHTML = "<div id='qrcode' ref='qrCodeUrl'></div>"
            new QRCode(this.$refs.qrCodeUrl, {
                text: res,//'https://blog.csdn.net/weixin_42601136', // 需要转换为二维码的内容
                width: 150,
                height: 150,
                colorDark: '#000000',
                colorLight: '#ffffff',
                bindElement: true,
                correctLevel: QRCode.CorrectLevel.H
            })
            setTimeout(() => {
                this.downloadCodeImg()
            }, 500)
            // setTimeout(() => {
            //     this.voidBut = false
            // }, 1000)

        },
        // 下载二维码
        downloadCodeImg() {
            let button = document.querySelector(".poster-download"); //下载按钮
            const scrollTop = document.documentElement.scrollTop || document.body.scrollTop // 获取滚动轴滚动的长度
            const width = document.querySelector(".poster-aside").offsetWidth
            const height = document.querySelector(".poster-aside").offsetHeight + 60//包裹容器的高度
            html2canvas(document.querySelector(".poster-aside"), {
                width, //画布的宽度，即生成图片的宽度
                height,//画布的宽度，同上
                scrollY: -scrollTop + 15, //生成的图片在画布上的偏移量，我这里加15的原因是让图片上下居中
                dpi: window.devicePixelRatio * 2, // 对应屏幕的dpi，适配高清屏，解决canvas模糊问题
                scale: 1, // 缩放
                useCORS: true, // 是否使用图片跨域，如何使本地图片不用配置
            }).then(canvas => {
                // canvas参数为生成的canvas的dom节点，可以对其进行dom操作
                // 下载功能
                // 设置a标签的download属性，点击a标签变为下载
                button.download = this.TwoCode.batchName// 设置下载的文件名
                button.href = canvas.toDataURL("image/png"); // a标签的url对应图片base64
            })
            // if (!this.voidBut) {
            //     this.voidBut = true
            // }else{
            //     this.voidBut = false
            // }
        },
        // 遍历班级
        classList(index) {
            let arr = []
            let int = Number(this.gradeClass.arrClass[index])
            // console.log(int);
            for (let i = 0; i < int; i++) {
                arr.push({
                    className: `${i + 1}班`
                })
                // console.log(arr);
            }
            this.gradeClass.arr[index].classAddListDto = arr
        },
        // 添加班级
        addClass() {
            this.gradeClass.arr.push({
                classAddListDto: [
                ],
                disabled: false,
                grade: '',
                schoolId: this.batchList.schoolId,
                batchId: this.batchId
            })
        },
        // 编辑班级
        editClass(item) {
            if (item.grade === '') {
                this.$message.error('请先填写年级')
            } else {
                let index = this.gradeClass.arr.indexOf(item)
                this.gradeClass.arr[index].disabled = true
                this.innerVisibleClass = true
                this.classDetails.index = index
                this.classDetails.cont = JSON.parse(JSON.stringify(item))
            }

        },
        // 删除年级
        removeGrade(item) {
            // console.log(item);
            // return
            let index = this.gradeClass.arr.indexOf(item)
            //console.log('arr', this.gradeClass.arr);
            //console.log(index);
            // this.gradeClass.arr.splice(index, 1)
            if (index !== -1) {
                this.gradeClass.arr.splice(index, 1)
                this.gradeClass.arrClass.splice(index, 1)
            }
        },
        // 添加年级班级
        async addGradeClass() {

            if (this.gradeClass.arr.length !== 0) {
                this.dialogGrade = false
                const res = await request({
                    method: 'POST',
                    url: '/admin/school/edit/grade/class',
                    data: this.gradeClass.arr
                })
                //console.log(res);
                if (res.code === '200') {
                    this.$message.success(res.message)
                } else {
                    this.$message.error(res.message)
                }
            } else {
                this.$message.error('请添加班级年级')
            }
        },
        // 取消添加年级班级
        cancelClass() {
            this.dialogGrade = false
            this.gradeClass.arr = []
        },
        // 添加年级班级弹窗
        async addGrade(val) {
            this.gradeClass.arr = []
            this.dialogGrade = true
            this.batchId = val.id
            //console.log(val);
            const res = await request({
                method: 'GET',
                url: `admin/school/select/grade/class?schoolId=${this.batchList.schoolId}&batchId=${val.id}`
            })
            if (res.code === '200') {
                // this.gradeClass.arr = res.data
                let arr = []
                res.data.forEach(v => {
                    // v.schoolId = val.id
                    v.classAddListDto = v.classAddListVo
                    arr.push(v.classAddListVo.length)
                })

                this.gradeClass.arrClass = arr
                this.gradeClass.arr = res.data
            } else {
                this.$message.error(res.message)
            }
            //console.log(res);
        },
        // 批次查询
        async getBatch() {
            const res = await request({
                method: 'POST',
                url: 'admin/school/batch/list',
                data: this.batchList
            })
            if (res.code === '200') {
                this.tableData = res.data && res.data.list
                this.total = res.data && res.data.total
            } else {
                this.$message.error(res.message)
            }
            //console.log(res);
        },
        // 搜索
        search() {
            this.batchList.pageNum = 1
            this.getBatch()
        },
        // 重置查询
        reset() {
            this.batchList.batchName = ''
            this.batchList.pageNum = 1
            this.batchList.pageSize = 10
            this.batchList.isPage = true
            this.getBatch()
        },
        // 是否关闭新增弹窗
        handleClose(done) {
            this.$confirm('确认关闭？')
                .then(() => {
                    done();
                })
                .catch(() => { });
        },
        // 打开新增弹窗
        openDialog(formName) {
            if (this.$refs[formName]) {
                this.resetForm(formName)
            }
            this.dialogVisible = true
            this.resetRuleForm()
        },
        // 表单校验
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.dialogVisible = false
                    this.addBatch()
                } else {
                    return false;
                }
            });
        },
        // 新增批次
        async addBatch() {
            const res = await request({
                method: "POST",
                url: "admin/school/add/batch",
                data: this.ruleForm
            })
            //console.log(res);
            if (res.code === '200') {
                this.$message.success(res.message)
                this.reset()
            } else {
                this.$message.error(res.message)
            }
        },
        // 重置效验
        resetForm(formName) {
            //console.log(this.$refs[formName]);
            this.dialogVisible = false
            this.$refs[formName].resetFields();
            this.resetRuleForm()
        },
        // 重置新增表单
        resetRuleForm() {
            this.ruleForm.id = ''
            this.ruleForm.batchName = ''
            this.ruleForm.batchLabel = ''
            this.ruleForm.startTime = ''
            this.ruleForm.endTime = ''
            this.ruleForm.noticeContent = ''
            this.ruleForm.phone = ''
            this.ruleForm.notification = ''
            this.ruleForm.notificationContent = ''
            this.ruleForm.shoppingContent = ''
            this.ruleForm.transportationTotal = ''
            this.ruleForm.period = ''
        },
        //编辑批次回显
        async editorEcho(val) {
            // //console.log(val.id);
            this.dialogVisible = true
            const res = await request({
                method: 'GET',
                url: `admin/school/select/batch?batchId=${val.id}`
            })
            if (res.code === '200') {
                // this.$message.success(res.message)
                this.ruleForm = res.data
                // console.log(res);
            } else {
                this.dialogVisible = false
                this.$message.error(res.message)
            }
            //console.log(res);
        },
        //编辑批次
        editorBatch(formName) {
            this.$refs[formName].validate(async (valid) => {
                if (valid) {
                    this.dialogVisible = false
                    const res = await request({
                        method: "POST",
                        url: "admin/school/update/batch",
                        data: this.ruleForm
                    })
                    //console.log(res);
                    if (res.code === '200') {
                        this.$message.success(res.message)
                        this.getBatch()
                    } else {
                        this.$message.error(res.message)
                    }
                } else {
                    return false;
                }
            });

        },
        // 删除批次
        deleteBatch(val) {
            this.$confirm('确认删除？')
                .then(async () => {
                    //console.log(val.id);
                    const res = await request({
                        method: "GET",
                        url: `admin/school/remove/batch?batchId=${val.id}`
                    })
                    //console.log(res);
                    if (res.code === '200') {
                        this.$message.success(res.message)
                        this.reset()
                    } else {
                        this.$message.error(res.message)
                    }
                })
                .catch(() => { });
        },
        // 确认签收
        forBatch(val) {
            this.$confirm('确认签收？')
                .then(async () => {
                    //console.log(val.id);
                    const res = await request({
                        method: "GET",
                        url: `admin/school/batch/for?batchId=${val.id}`
                    })
                    //console.log(res);
                    if (res.code === '200') {
                        this.$message.success(res.message)
                        this.reset()
                    } else {
                        this.$message.error(res.message)
                    }
                })
                .catch(() => { });
        },
        // 编辑批次商品弹窗
        batchGrade(val, formName) {
            // console.log(val);
            this.isTransportationTotal = false
            if (this.$refs[formName]) {
                this.$refs[formName].resetFields();
            }
            //console.log(val);
            this.batchGoods.batchId = val.id
            this.batchGoods.addBatchGoodsListDtos = []
            this.imgUrlBig = []
            // let a = Date.parse(this.currentTime)
            // console.log( a, Date.parse(val.startTime));
            // console.log(this.currentTime >= val.startTime);
            // return
            if (Date.parse(this.currentTime) >= Date.parse(val.startTime)) {
                this.isTrue = true
            } else {
                this.isTrue = false
            }
            this.outerVisible = true
            if (val.logisticsType === '2') {
                this.isTransportationTotal = true
            }
            this.batchGoodsEcho(val.id)
        },
        // 编辑批次表单校验
        submitFormGoods(formName) {
            if (this.batchGoods.addBatchGoodsListDtos.length > 0) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.submitBatchGoods()
                    } else {
                        return false;
                    }
                });
            } else {
                this.$message.error('请添加商品！')
            }
        },
        // 批次商品提交
        async submitBatchGoods() {
            //console.log(this.batchGoods);
            let status = false
            this.batchGoods.addBatchGoodsListDtos.forEach(val => {
                //console.log(val);
                if (val.setCount <= val.setMaxCount) {
                    status = true
                } else {
                    status = false
                    return
                }
            })
            if (status) {
                this.outerVisible = false
                const res = await request({
                    method: "POST",
                    url: 'admin/school/edit/batch/goods',
                    data: this.batchGoods
                })
                //console.log(res);
                if (res.code === '200') {
                    this.$message.success(res.message)
                    this.batchGoods.addBatchGoodsListDtos = []
                    this.imgUrlBig = []
                } else {
                    this.$message.error(res.message)
                }
            } else {
                this.$message.error("最大数量错误")
            }

        },
        // 添加商品弹窗
        addDoodsDialog() {
            this.goodsListParameter.pageNum = 1
            this.innerVisible = true
            this.getGoods()
        },
        // 获取商品
        async getGoods() {
            const res = await request({
                method: "POST",
                url: "admin/commodity/warehouse/findGoods",
                data: this.goodsListParameter
            })
            if (res.code === '200') {
                this.goodsList = res.data && res.data.list
                this.totalPage = res.data && res.data.totalPage
            } else {
                this.$message.error(res.message)
            }
            //console.log(res);
        },
        // 商品搜索
        async searchGoods() {
            this.goodsListParameter.pageNum = 1
            this.getGoods()
        },
        // 重置商品
        resetGoods() {
            this.goodsListParameter.pageNum = 1
            this.goodsListParameter.goodsName = ''
            this.getGoods()
        },
        // 加载更多商品
        async loadMoreGoods() {
            let num = this.goodsListParameter.pageNum
            this.goodsListParameter.pageNum = num + 1
            if (this.goodsListParameter.pageNum <= this.totalPage) {
                const res = await request({
                    method: "POST",
                    url: "admin/commodity/warehouse/findGoods",
                    data: this.goodsListParameter
                })
                if (res.code === '200') {
                    let data = res.data && res.data.list
                    this.totalPage = res.data && res.data.totalPage
                    let goodsList = this.goodsList
                    this.goodsList = goodsList.concat(data)
                } else {
                    this.$message.error(res.message)
                }
            } else {
                this.$message.warning('没有更多了')
            }

        },
        //选中商品
        activeImg(index) {
            let attr = JSON.parse(event.currentTarget.getAttribute("attr"))
            //console.log(index, attr);
            this.isActive = index
            this.isActiveAttr = attr
        },
        // 确定选中图片
        determineGoods() {
            if (this.isActiveAttr) {
                //console.log(this.isActiveAttr);
                let g = this.isActiveAttr
                // let index = g.pictureUrl.indexOf('file')
                // let picture = g.pictureUrl.slice(index + 4)
                let picture = g.pictureUrl
                let goods = {
                    goodsId: g.id,
                    goodsName: g.goodsName,
                    pictureUrl: picture,
                    logisticsType: '',
                    setAmount: '',
                    setCount: '',
                    setMaxCount: '',
                    discountCount: '',
                    goodsSort: '',
                    transportationTotal: ''
                }
                if (this.isTransportationTotal) {
                    goods.transportationTotal = g.weight
                }
                let batchGoodsName = this.batchGoods.addBatchGoodsListDtos.map(item => item['goodsId'])
                //console.log(batchGoodsName.indexOf(goods.goodsId));
                if (batchGoodsName.indexOf(goods.goodsId) === -1) {
                    this.batchGoods.addBatchGoodsListDtos.push(goods)
                    this.imgUrlBig.push([g.pictureUrl])
                    this.isActiveAttr = ''
                    this.isActive = ''
                    this.innerVisible = false
                } else {
                    this.$message.warning("商品重复！")
                }

                return
            } else {
                this.$message.error("请选择商品！")
            }
        },
        // 取消选中
        cancelSelect() {
            this.isActiveAttr = ''
            this.isActive = ''
            this.innerVisible = false
        },
        // 批次商品回显
        async batchGoodsEcho(id) {
            const res = await request({
                method: "GET",
                url: `admin/school/select/batch/goods?batchId=${id}`
            })
            //console.log(res);
            //console.log(res.code);
            if (res.code === '200') {
                if (res.data.length > 0) {
                    //console.log(res.data.length);
                    res.data.forEach(v => {
                        // let index = v.goodsDetailsVo.pictureUrl.indexOf('file')
                        // let pictureUrl = v.goodsDetailsVo.pictureUrl.slice(index + 4)
                        let pictureUrl = v.goodsDetailsVo.pictureUrl
                        //console.log(pictureUrl, 11111111111, 'index', index);
                        let attr = {
                            goodsName: v.goodsDetailsVo.goodsName,
                            goodsId: v.goodsId,
                            pictureUrl: pictureUrl,
                            setAmount: v.setAmount,
                            setCount: v.setCount,
                            setMaxCount: v.setMaxCount,
                            discountCount: v.discountCount,
                            goodsSort: v.goodsSort,
                            transportationTotal: v.transportationTotal
                        }
                        //console.log('attr', attr);
                        // //console.log(this.batchGoods.addBatchGoodsListDtos.push(attr));
                        this.batchGoods.addBatchGoodsListDtos.push(attr)
                        // //console.log(Array.isArray(this.batchGoods.addBatchGoodsListDtos));
                        //     //console.log('this.batchGoods.addBatchGoodsListDtos', this.batchGoods.addBatchGoodsListDtos);
                        this.imgUrlBig.push([v.goodsDetailsVo.pictureUrl])
                    });

                } else {
                    return
                }
            } else {
                this.$message.error(res.message)
            }
        },
        // 删除批次商品
        removeGoods(item) {
            //console.log(item);
            let index = this.batchGoods.addBatchGoodsListDtos.findIndex(val => val.goodsId === item.goodsId)//
            //console.log(index);
            this.batchGoods.addBatchGoodsListDtos.splice(index, 1)
            this.imgUrlBig.splice(index, 1)
        },
        // 多选
        handleSelectionChange() { },
        // 分页
        handleCurrentChange() {
            this.getBatch()
        }
    },
    created() {
        this.batchList.schoolId = this.$route.query.id
        this.ruleForm.schoolId = this.$route.query.id
        this.batchGoods.schoolId = this.$route.query.id
        this.getBatch()
        this.getTimesInterval()
    },
    mounted() { },
    watch: {
        'ruleForm.notification'(newVal) {
            if (newVal !== 1) {
                this.ruleForm.notificationContent = ''
            }
        },
        'ruleForm.logisticsType'(newVal) {
            if (newVal !== '快递到家') {
                this.ruleForm.transportationTotal = ''
            }
        }
    },
    filters:{
        isSignFor:function(val){
            if (val) {
                return '已签收'
            } else {
                return '未签收'
            }
        }
    }

}
</script>

<style lang="scss" scoped>
.list {
    background-color: #2589ff;
    color: #fff;
    text-align: center;
    width: 106px;
    height: 36px;
    margin-right: 10px;
    font-size: 16px;
    line-height: 36px;
    display: inline-block;
    border-radius: 6px;
}

.content {
    margin: 20px 0 0 0;
    background-color: #e0e0e0;
    padding: 10px;
    border-radius: 5px;
}

.goods {
    background-color: #fff;
    border-radius: 5px;
    padding: 10px 20px;
    // display: flex;
    // justify-content: space-between;
}

.el-select .el-input {
    width: 130px;
}

.input-with-select .el-input-group__prepend {
    background-color: #fff;
}

.block {
    text-align: right;
    background-color: #fff;
}

.img-choose {
    height: 500px;
    overflow: auto;
    display: flex;
    // justify-content: space-between;
    flex-wrap: wrap;

    .single-goods {
        width: 150px;
        position: relative;
        // background-color: red;
        margin: 0 10px 10px 10px;

        img {
            width: 100%;
            height: 150px;
        }
    }
}

.is-active {
    width: 100%;
    height: 20px;
    opacity: 0.5;
    background-color: #000;
    position: absolute;
    left: 0;
    top: 130px;
}

.img-search {
    margin-bottom: 20px;
    text-align: right;

    .el-input {
        width: 200px;
    }
}

.notice-content {
    height: 50px;
}

.left .el-tooltip__popper,
.right .el-tooltip__popper::v-deep {
    padding: 8px 10px;
}

#poster-aside {
    position: relative;
    background-color: #000;
    height: 600px;
    margin-bottom: 60px;

    .code-cont {
        // background-color: red;
        width: 400px;
        z-index: 99999;
        top: -20px;
        left: -20px;
        position: absolute;

        p {
            text-align: center;
            color: #fff;
        }

        .head-text {
            margin-top: 20px;
        }

        .title {
            margin-top: 30px;
            font-weight: bold;
        }

        .subscription-time {
            margin-top: 15px;
        }

        .cont {
            width: 320px;
            height: 500px;
            background-color: #fff;
            margin: 30px auto;
            border-radius: 10px;
            align-items: center;
            overflow: hidden;
            padding: 0 20px;

            .logo {
                position: relative;
                margin-top: 30px;

                // padding: 0 20px;
                img {
                    width: 40px;
                    height: 40px;
                    position: absolute;
                    top: -10px;
                }

                span {
                    font-size: 16px;
                    font-weight: bold;
                    margin-left: 50px;
                    color: #000;
                    display: block;
                }
            }

            .subscription-prompt {
                margin-top: 25px;
                font-weight: bold;
                color: #000;
                font-size: 14px;
            }

            .tow-code {
                width: 230px;
                height: 230px;
                background-color: #fafafa;
                margin: 25px auto 0;
                overflow: hidden;

                #qrcode {
                    width: 150px;
                    height: 150px;
                    // background-color: pink;
                    margin: 10px auto 0;
                }

                span {
                    padding: 0 15px;
                    margin-top: 15px;
                    display: block;
                    font-size: 10px;
                    text-align: center;
                }
            }

            .school-number {
                text-align: center;
                margin-top: 25px;
                font-weight: bold;
                color: #000;
            }

            .contact-number {
                text-align: center;
                margin-top: 10px;
                font-weight: bold;
                color: #000;
            }

            .company-name {
                text-align: center;
                margin-top: 10px;
            }
        }
    }

    .img {
        width: 400px;
        position: absolute;
        top: -20px;
        left: -20px;
    }
}

.el-dialog__body::v-deep {
    padding: 0 !important;
}

.poster-download {
    display: inline-block;
    background-color: #0ebfdf;
    padding: 4px 10px 5px;
    margin-left: 10px;
    position: relative;
    top: 2px;
    border-radius: 3px;
    cursor: pointer;
}

.dialog-footer {
    position: relative;

    .void-but {
        position: absolute;
        bottom: -10px;
        right: 0px;
    }
}

.itme {
    line-height: 40px;
    height: 10px;
}

.notice-content {
    height: 20px;
    overflow: hidden;
    padding: 0 10px;
    text-overflow: ellipsis;
    white-space: nowrap;
}
</style>